export default __webpack_public_path__ + "static/media/burguer.5ce7477a.svg";